import { useNavigate, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Tabs, Tab } from '@mui/material';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentTab = () => {
    const path = location.pathname;
    if (path.includes('/announcement')) return 0;
    if (path.includes('/system')) return 1;
    if (path.includes('/information')) return 2;
    return 0;
  };

  const handleChange = (_event, newValue) => {
    const paths = ['/announcement', '/system', '/information'];
    navigate(paths[newValue]);
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: '#ff5722', width: '100%', boxSizing: 'border-box', height: '10vh' }}>
      <Toolbar sx={{
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        pt: 0,
        pb: 0,
        px: { xs: 0.5, sm: 1, md: 1.5 },
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        minHeight: 'auto',
        height: '100%'
      }}>
        {/* <Typography variant="h5" component="div" sx={{
          fontWeight: 'bold',
          mb: { xs: 1, sm: 1.5 },
          color: 'white',
          textAlign: 'center',
          fontSize: { xs: '1.2rem', sm: '1.5rem' },
          width: '100%'
        }}>
          NEWS & ANNOUNCEMENTS
        </Typography> */}
        <Tabs
          value={getCurrentTab()}
          onChange={handleChange}
          textColor="inherit"
          variant="fullWidth"
          TabIndicatorProps={{
            style: { backgroundColor: 'white', height: 3 }
          }}
          sx={{
            width: '100%',
            height: '100%',
            '& .MuiTabs-flexContainer': {
              height: '100%'
            },
            '& .MuiTab-root': {
              color: 'rgba(255, 255, 255, 0.7)',
              fontWeight: 'bold',
              fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
              flex: 1,
              maxWidth: 'none',
              padding: { xs: '0 8px', sm: '0 16px', md: '0 16px' },
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            },
            '& .Mui-selected': {
              color: 'white',
            }
          }}
        >
          <Tab label="ANNOUNCEMENT" />
          <Tab label="SYSTEM" />
          <Tab label="INFORMATION" />
        </Tabs>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
